import { render, staticRenderFns } from "./ComponentTraceabilityTab.vue?vue&type=template&id=138b01fa&scoped=true&"
import script from "./ComponentTraceabilityTab.vue?vue&type=script&lang=js&"
export * from "./ComponentTraceabilityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b01fa",
  null
  
)

export default component.exports